import { Navigate, useParams } from 'react-router-dom';

interface BatchScopedRedirectProps {
  suffix: 'dismantling' | 'outbounds';
}

/**
 * Compatibility redirect for retired batch-scoped operational pages.
 * Keeps historical bookmarks usable without exposing a second writer.
 */
const BatchScopedRedirect = ({ suffix }: BatchScopedRedirectProps) => {
  const { batchId } = useParams<{ batchId: string }>();
  return <Navigate replace to={batchId ? `/batches/${batchId}/${suffix}` : '/batches'} />;
};

export default BatchScopedRedirect;
